import type { ReactNode } from 'react';
import {
  FormControl,
  FormHelperText,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';

export const FieldSkeleton = ({ withoutLabel }: { withoutLabel?: true }) => (
  <FormControl fullWidth>
    <Stack spacing={1}>
      {!withoutLabel && (
        <Typography component="div">
          <Skeleton width="30%" height={22} />
        </Typography>
      )}
      <Skeleton height={40} variant="rounded" />
    </Stack>
    <FormHelperText />
  </FormControl>
);

interface FieldWrapperProps {
  loading: boolean;
  children: ReactNode;
  withoutLabel?: true;
}

export const FieldWrapper = ({
  loading,
  children,
  withoutLabel,
}: FieldWrapperProps) => {
  return loading ? <FieldSkeleton withoutLabel={withoutLabel} /> : children;
};
